import React from 'react'
interface NoDataFoundProps {
  image?: string;
  message?: string;
}

function NoDataFound({
  image = "/images/coupan_card.svg",
  message = "No Data Found",
}: NoDataFoundProps) {
  return (
    <div className="no_data_found">
      <figure>
        <img src={image} alt="no data" />
      </figure>
      <p>{message}</p>
    </div>
  )
}

export default NoDataFound